import {
  OrderV2Dto,
  SupplierRelationshipFulfillmentType,
} from "@sellar-io/api-v2/types";
import { useLocalStorage } from "usehooks-ts";

const BUYERS_CHOICE_FULFILLMENT_TYPE_KEY = "buyers-choice";

export type BuyersChoiceFulfillmentType = Extract<
  SupplierRelationshipFulfillmentType,
  "direct" | "sellarDistribution"
>;

const validBuyersChoiceFulfillmentTypes: BuyersChoiceFulfillmentType[] = [
  "direct",
  "sellarDistribution",
];

export const useStorefrontBuyerChoiceDeliveryOption = ({
  supplierId,
}: {
  supplierId: number;
}) => {
  const [buyersChoiceFulfillmentType, saveBuyersChoiceFulfillmentType] =
    useLocalStorage<BuyersChoiceFulfillmentType | undefined>(
      `${BUYERS_CHOICE_FULFILLMENT_TYPE_KEY}-${supplierId}`,
      undefined,
    );

  const isValidBuyersChoiceFulfillmentType = (
    fulfillmentType: OrderV2Dto.OrderCreateRequestType["fulfillmentType"],
  ): fulfillmentType is BuyersChoiceFulfillmentType => {
    if (!fulfillmentType) {
      return false;
    }
    return validBuyersChoiceFulfillmentTypes.includes(fulfillmentType);
  };

  return {
    buyersChoiceFulfillmentType,
    saveBuyersChoiceFulfillmentType,
    isValidBuyersChoiceFulfillmentType,
  };
};
